<template>
  <div>
    <b-modal :no-fade="true" :id="modalID" :ref="modalID" title="Alterar Senha">
      <b-row>
        <b-col lg="12">
          <b-form-group id="fieldset-1" label="Usuário" label-for="cp_user">
            <b-form-input id="cp_user" disabled v-model="user" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-form-group id="fieldset-2" label="Senha Atual" label-for="cp_actual">
            <b-form-input id="cp_actual" type="password" maxlength="20" v-model="currentPassword" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-form-group id="fieldset-3" label="Nova Senha" label-for="cp_new">
            <b-form-input id="cp_new" type="password" v-model="newPassword" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-form-group id="fieldset-4" label="Confirmação" label-for="cp_confirm">
            <b-form-input id="cp_confirm" type="password" v-model="confirmation" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <template v-slot:modal-footer>
        <b-button variant="primary" @click="ok()">OK</b-button>
        <b-button variant="secondary" @click="cancel()">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {baseApiUrl, showError} from '@/global'
import axios from 'axios'
export default {
  name: "ChangePassword",
  props: ["user", "modalID"],
  data: function() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmation: "",
      curUser: {}
    };
  },
  methods: {
    ok() {
        if(this.newPassword.toLowerCase() !== this.confirmation.toLowerCase()){
            this.$toasted.info("Senha não confere!", {
                duration: 3500,
                keepOnHover: true,
                className: "v-toasted-warning"
            });            
            
        }
        axios.post(`${baseApiUrl}/usuarios/changepwd2`, {email: this.user.email, senha: this.newPassword.toLowerCase()})
            .then( () => {
                this.$toasted.info("Senha Alterada!", {
                    duration: 3500,
                    keepOnHover: true,
                });            

                this.$bvModal.hide(this.modalID);
            })
            .catch(ex => showError(ex))
    },
    cancel() {
      this.$bvModal.hide(this.modalID);
    }
  }
};
</script>

<style>
</style>